import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* disconnectFromPhoneBridgeSaga() {
  yield call(SignalingSocket.send, { event: 'disconnectFromPhoneBridge' });
}
